var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('CrudIndex',{attrs:{"title":"GL Accounts","viewColumns":_vm.columns,"permission":_vm.PERMISSION_CODES.CMS_VIEW_GL_ACCOUNT,"fetchUrl":"/gl-accounts/formatted","createUrl":"/gl-accounts","updateRootUrl":"/gl-accounts","deleteRootUrl":"/gl-accounts","createFields":_vm.createFields,"reloadOnSuccess":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }